import CnpjValidation from './rules/cnpj'
export default function (value, args) {
  return CnpjValidation(value)
}